import React from "react";
import bnr1 from "../../assets/HomeImages/interiordesignleftone.png";
import bnr2 from "../../assets/HomeImages/interiordesignrightone.png";

const InteriorDesign = () => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center gap-6 px-3 sm:px-6 lg:px-8 bg-white">
      <div className="w-full md:w-1/2 h-52 sm:h-64 rounded-xl overflow-hidden shadow-lg">
        <img
          src={bnr1}
          alt="Interior Design"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="w-full md:w-1/2 h-52 sm:h-64 rounded-xl overflow-hidden shadow-lg flex mt-4 md:mt-0">
        <img
          src={bnr2}
          alt="Bathroom Design"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default InteriorDesign;
